import { useState, useEffect, useRef } from "react";
import { Formik, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import Controls from "../../components/FormsUI";
import { useAuth } from "../../utility/auth";
import ImagePreview from "../../components/FormsUI/PreviewImage/index";
import ServiceController from "../../controller/ServiceController.jsx";
import DepartmentController from "../../controller/DepartmentController";
import SubDepartmentController from "../../controller/SubDepartmentController";
import CustomizedSnackbars from "../../components/Alert";
import EditIcon from "@mui/icons-material/Edit";
import Load from "../../components/FormsUI/Loader/index";//../components/FormsUI/Loader/index
import DeleteIcon from "@mui/icons-material/Delete";
import "../../css/style.css";
import { tokens } from "../../theme";
import {
    Container,
    Grid,
    useTheme,
    Box,
    Stack,
    IconButton,
} from "@mui/material";
import ExceptionHandlerController from "../../controller/ErrorLogsController";


const INITIAL_FORM_STATE = {
    serviceName: "",
    serviceRemark: "",
    departmentId: "",
    subDepartmentId: "",
};
const FORM_VALIDATION = Yup.object().shape({
    serviceName: Yup.string()
        .matches(/^[A-Za-z ]*$/, "Sub Department Name is not in correct format")
        .trim("No white space allowed")
        .strict(true)
        .min(3, "Minimum 3 characters required")
        .max(100, "Sub Department Name should not exceed 100 characters")
        .required("Sub Department Name is required"),
    departmentId: Yup.string()
        .matches(/^[0-9a-fA-F]{24}$/, "Invalid Department DepartmentId format") // ✅ Only for ObjectId
        .required("Department name is required"),
    subDepartmentId: Yup.string()
        .matches(/^[0-9a-fA-F]{24}$/, " Invalid Department subDepartmentId format") // ✅ Only for ObjectId
        .required("sub-department name is required"),
    serviceRemark: Yup.string()
        .matches(/^[A-Za-z0-9 ]*$/, "Service Remark  is not in correct format")
        .trim("No white space allowed")
        .strict(true)
        .min(2, "Minimum 2 characters required")
        .max(200, "Service Remark should not exceed 20 characters")
        .optional(),
    // subDepartmentImage: Yup.mixed().optional(),

});


let requestType = "";
const Services = () => {
    const fileInputRef = useRef(null);
    const serviceController = new ServiceController();
    const departmentController = new DepartmentController();
    const subDepartmentController = new SubDepartmentController();
    const exceptionHandlerController = new ExceptionHandlerController();
    const auth = useAuth();
    const user = auth.decoder(sessionStorage.getItem("user"));
    const { data, token } = user;
    const { userid: userId, tenantid: tenantId } = data.UserInfo;
    const [departmentOptions, setDepartmentOptions] = useState();
    const [subDepartmentOptions, setSubDepartmentOptions] = useState();
    const [service, setService] = useState([])

    // const [subDepartmentImage, setSubDepartmentImage] = useState();
    // const [popupPreview, setPopUpPreview] = useState({
    //     subDepartmentImage: false
    // });
    // const previewPopUpImage = (field, value) =>
    //     setPopUpPreview((prev) => ({ ...prev, [field]: value }));
    const [loader, setLoader] = useState(true);
    const [departmentId, setDepartmentId] = useState('');
    const [updatedValues, setUpdatedValues] = useState(INITIAL_FORM_STATE);
    const [alert, setAlert] = useState({ counter: 0, type: "", msg: "" });
    const [popup, setPopUp] = useState(false);
    const [allUsers, setAllUsers] = useState([]);

    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    useEffect(() => {
        getAllService();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const getAllDepartment = async () => {
        let caughtError;
        try {
            const response = await departmentController.GetDepartmentOptions(token);
            if (response.status === 200) {
                const departmentData = response?.data?.body?.map((item) => ({
                    // ...item,
                    departmentName: item.departmentName,
                    departmentId: item._id,
                }));
                setDepartmentOptions(departmentData);
            }
        } catch (error) {
            caughtError = error;
            let logData = {};
            logData.message = caughtError?.message;
            logData.stack = caughtError?.stack;
            let logError = {
                logData,
                module: "getAllDepartment in service page",
            };
            exceptionHandlerController.HandleException(logError);
        }
    };
    const getSubDepartment = async (departmentId) => {
        let caughtError;
        try {
            const response = await subDepartmentController.GetSubDepartmentById(departmentId, token);
            if (response.status === 200) {
                const subDepartmentData = response?.data?.body?.map((item) => ({
                    // ...item,
                    subDepartmentName: item.subDepartmentName,
                    subDepartmentId: item._id,
                }));
                setSubDepartmentOptions(subDepartmentData);
            }
        } catch (error) {
            caughtError = error;
            let logData = {};
            logData.message = caughtError?.message;
            logData.stack = caughtError?.stack;
            let logError = {
                logData,
                module: "getSubDepartment in Service Page",
            };
            exceptionHandlerController.HandleException(logError);
        }
    };
    const getAllService = async () => {
        let caughtError;
        try {
            const response = await serviceController.GetAllService(token);
            if (response.status === 200) {
                const serviceData = response?.data?.body?.map((item) => ({
                    ...item,
                    id: item._id,
                }));
                setService(serviceData ?? '');
            }
            else if (response?.data?.status === 404) {
                showAlert("error", response?.data?.message);
            } else if (response?.status === 500) {
                showAlert("error", response?.response?.data?.message);
            }
            setLoader(() => false);
        } catch (error) {
            caughtError = error;
            let logData = {};
            logData.message = caughtError?.message;
            logData.stack = caughtError?.stack;
            let logError = {
                logData,
                module: "getAllService",
            };
            exceptionHandlerController.HandleException(logError);
        }
    };

    const showAlert = (type, msg) => {
        const notify = { ...alert };
        notify.counter = notify.counter + 1;
        notify.type = type;
        notify.msg = msg;
        setAlert(notify);
    };

    const columns = [
        {
            headerName: "ID",
            field: "id",
            hide: true,
            filterable: false,
            width: 210,
        },
        { headerName: "Service Name", field: "serviceName", width: 210 },
        { headerName: "Service Remark", field: "serviceRemark", width: 210 },
        {
            field: "action",
            headerName: "Action",
            width: 210,
            sortable: false,
            filterable: false,
            disableExport: true,
            disableClickEventBubbling: true,

            renderCell: (params) => {
                const onClick = (e, type) => {
                    let caughtError;
                    try {
                        setAlert({ counter: 0, type: "", msg: "" });
                        const currentRow = params?.row;
                        if (type === "Edit") {
                            requestType = "Edit";
                            setUpdatedValues(() => currentRow);
                            const currentRowData = currentRow;
                            setUpdatedValues(() => currentRowData);
                            // setSubDepartmentImage(currentRow.subDepartmentImage)
                            setDepartmentOptions([{
                                departmentName: currentRow.departmentName,
                                departmentId: currentRow.departmentId
                            }])
                            setSubDepartmentOptions([{
                                subDepartmentName: currentRow.subDepartmentName,
                                subDepartmentId: currentRow.subDepartmentId
                            }])
                            getAllDepartment()
                            getSubDepartment(currentRow.departmentId);
                            handleData();
                        } else {
                            serviceController
                                .Delete(currentRow.id, token)
                                .then((response) => {
                                    if (response.status === 200) {
                                        getAllService()
                                        showAlert("success", "Deleted successfully");
                                        setAllUsers((i) => {
                                            return allUsers.filter(
                                                (item) => item?.id !== currentRow.id
                                            );
                                        });
                                    } else if (response.data.status === 404) {
                                        showAlert("error", response.data.message);
                                    }
                                    else if (response?.status === 500) {
                                        showAlert("error", response?.response?.data?.message);
                                    }
                                })
                                .catch((error) => {
                                    showAlert("error", "Oops something went wrong.");
                                    setTimeout(() => {
                                        setAlert({ counter: 0, type: "", msg: "" });
                                    }, 10000);
                                });
                        }
                    } catch (error) {
                        caughtError = error;
                        let logData = {};
                        logData.message = caughtError?.message;
                        logData.stack = caughtError?.stack;
                        let logError = { logData, module: "Department onClick(Edit) method" };
                        exceptionHandlerController.HandleException(logError);
                    }
                };

                return (
                    <Stack direction="row" spacing={2}>
                        <>
                            <IconButton onClick={(e) => onClick(e, "Edit")}>
                                <EditIcon type="button" color="primary" id="Edit" />
                            </IconButton>
                            <IconButton>
                                <DeleteIcon
                                    type="button"
                                    color="secondary"
                                    id="Delete"
                                    onClick={(e) => onClick(e, "Delete")}
                                />
                            </IconButton>
                        </>
                    </Stack>
                );
            },
        },
    ];

    const AddDepartment = async () => {
        // getRolesDD();
        getAllDepartment();
        // getSubDepartment(departmentId);
        requestType = "Add";
        setUpdatedValues(() => INITIAL_FORM_STATE);
        // setSubDepartmentImage(null)
        handleData();
    };


    const submitValues = (submitValueData) => {
        let submitData = {};
        // tenantId coming from parent/component
        submitData.tenantId = tenantId;

        // submitData.append("tenantId", tenantId);
        // Map form fields
        submitData.serviceName = submitValueData?.serviceName?.trim() ?? "";
        submitData.serviceRemark = submitValueData?.serviceRemark?.trim() ?? "";
        submitData.departmentId = submitValueData?.departmentId?.trim() ?? "";
        submitData.subDepartmentId = submitValueData?.subDepartmentId?.trim() ?? "";

        //add for image
        if (requestType === "Edit") {
            submitData.id = submitValueData?.id?.trim() ?? "";

            const serviceId = submitValueData?.id;
            // assuming ID comes from backend
            serviceController
                .Update(serviceId, submitData, token)
                .then((response) => {
                    if (response.status === 200) {
                        getAllService();
                        showAlert("success", response?.data?.message);
                        handlePopup(false);
                        setTimeout(() => setAlert({ counter: 0, type: "", msg: "" }), 10000);
                        // getAllCenters();
                    } else {
                        if (response?.data?.status === 204)
                            showAlert("error", response?.data?.message);
                        else if (response?.response?.status === 409)
                            showAlert("error", response?.response?.data?.message);
                        else if (response?.status === 500)
                            showAlert("error", response?.response?.data?.message);

                        setTimeout(() => setAlert({ counter: 0, type: "", msg: "" }), 10000);
                    }
                })
                .catch((error) => {
                    showAlert("error", "Oops something went wrong.");
                    setTimeout(() => setAlert({ counter: 0, type: "", msg: "" }), 10000);
                });
        } else {
            serviceController
                .Create(submitData, token)
                .then((response) => {
                    if (response?.status === 201) {
                        getAllService();
                        handlePopup(false);
                        showAlert("success", response?.data?.message);
                        setTimeout(() => setAlert({ counter: 0, type: "", msg: "" }), 10000);
                    } else if (response?.response?.status === 500) {
                        showAlert("error", response?.response?.data?.message);
                    } else if (response?.response?.status === 409) {
                        showAlert("error", response?.response?.data?.message);
                    }
                    setTimeout(() => setAlert({ counter: 0, type: "", msg: "" }), 10000);
                })
                .catch((error) => {
                    showAlert("error", "Oops something went wrong.");
                    setTimeout(() => setAlert({ counter: 0, type: "", msg: "" }), 10000);
                });
        }
    };


    const handlePopup = (value) => setPopUp(() => value);
    const handleData = () => setPopUp(() => true);
    if (loader) return <Load />;
    return (
        <>
            <Box
                sx={{
                    "& .formBg": {
                        border: `1px solid ${colors.grey[900]}`,
                        background: `${colors.primary[400]}`,
                    },
                    "& li.MuiBreadcrumbs-li h6": { color: `${colors.primary[200]}` },
                    "& .MuiGrid-root.Mui-heading h2": {
                        color: `${colors.primary[200]} !important`,
                    },
                }}
            >
                <Grid container>
                    <Grid className="breadcrumb-section">
                        <Grid className="breadcrumb-container">
                            <Grid className="Mui-li">
                                <nav className="Mui-nav" aria-label="breadcrumb">
                                    <ol className="">
                                        <li className="MuiBreadcrumbs-li">
                                            <h6 className="breadsub">Medical</h6>
                                        </li>
                                        <li aria-hidden="true" className="MuiBreadcrumbs-separator">
                                            /
                                        </li>
                                        <li className="MuiBreadcrumbs-li">
                                            <h6>Services</h6>
                                        </li>
                                    </ol>
                                </nav>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} md={12} className="adduser">
                        <Controls.ActionButton onClick={() => AddDepartment()}>
                            <span>Add New</span>
                        </Controls.ActionButton>
                    </Grid>
                    <Grid item xs={12} className="formBg">
                        <Container maxWidth="md" className="formClwidth">
                            <div>
                                <Controls.Grid
                                    columns={columns}
                                    data={service}
                                    fileName={"Users"}
                                />
                                {popup && (
                                    <Controls.Popup
                                        title="Service "
                                        openPopup={popup}
                                        setOpenPopup={handlePopup}
                                    >
                                        <Formik
                                            enableReinitialize
                                            initialValues={{
                                                ...(updatedValues || INITIAL_FORM_STATE),
                                            }}
                                            validationSchema={FORM_VALIDATION}
                                            onSubmit={(values) => submitValues(values)}
                                        >
                                            {({ values, setFieldValue }) => (
                                                <Form>
                                                    <Grid container spacing={2}>
                                                        <Grid item xs={12} md={6}>
                                                            <Controls.Textfield
                                                                name="serviceName"
                                                                label="Service Name"
                                                                type="string"
                                                                inputProps={{ maxLength: 100 }}
                                                            />
                                                        </Grid>

                                                        <Grid item xs={12} md={6}>
                                                            <Controls.Textfield
                                                                name="serviceRemark"
                                                                label="Service Remark"
                                                                type="string"
                                                                inputProps={{ maxLength: 200 }}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={12} md={6}>
                                                            <Controls.AutoComplete
                                                                name="departmentId"
                                                                value={
                                                                    departmentOptions?.find(
                                                                        (opt) => opt.departmentId === values.departmentId) || null
                                                                }
                                                                label={
                                                                    <span>
                                                                        Select Department <span className="asterisk">*</span>
                                                                    </span>
                                                                }
                                                                options={departmentOptions || []}
                                                                getOptionLabel={(option) => option?.departmentName || ""}
                                                                isOptionEqualToValue={(option, value) => option?.departmentId === value?.departmentId}
                                                                onChange={(event, value) => {
                                                                    setSubDepartmentOptions([])
                                                                    setFieldValue("departmentName", value ? value.departmentName : ""); // ✅ only save string
                                                                    setFieldValue("departmentId", value ? value.departmentId : ""); // ✅ only save string
                                                                    getSubDepartment(value.departmentId)
                                                                    setDepartmentId(value.departmentId)
                                                                }}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={12} md={6}>
                                                            <Controls.AutoComplete
                                                                name="subDepartmentId"
                                                                value={
                                                                    subDepartmentOptions?.find(
                                                                        (opt) => opt.subDepartmentId === values.subDepartmentId) || null
                                                                }
                                                                label={
                                                                    <span>
                                                                        Select Sub-department <span className="asterisk">*</span>
                                                                    </span>
                                                                }
                                                                options={subDepartmentOptions || []}
                                                                getOptionLabel={(option) => option?.subDepartmentName || ""}
                                                                isOptionEqualToValue={(option, value) => option?.subDepartmentId === value?.subDepartmentId}
                                                                onChange={(event, value) => {
                                                                    setFieldValue("subDepartmentName", value ? value.subDepartmentName : ""); // ✅ only save string
                                                                    setFieldValue("subDepartmentId", value ? value.subDepartmentId : ""); // ✅ only save string
                                                                }}
                                                            />
                                                        </Grid>
                                                    </Grid>
                                                    <Grid item xs={4} md={2} className="marginAuto">
                                                        <Controls.Button>Submit</Controls.Button>
                                                    </Grid>
                                                </Form>
                                            )}
                                        </Formik>
                                    </Controls.Popup>
                                )}
                            </div>
                        </Container>
                    </Grid>
                    {alert?.counter > 0 && (
                        <CustomizedSnackbars
                            status={alert?.counter}
                            msg={alert?.msg}
                            type={alert?.type}
                        />
                    )}
                </Grid>
            </Box>
        </>
    );
};

export default Services;
